<template>
  <div class="panel-pages-container">
    <!---------------------------------->
    <div class="block-back-to-segment" v-if="showScreen">
      <div class="backbtn-segment" v-on:click="closeSegmentCards">
        <i class="fa fa-arrow-left"></i> Retour
      </div>
      <div class="current-segment-block">
        <div class="custom-folder xs small darckblue">
          <p>{{ currentSegment.title }}</p>
        </div>
      </div>
    </div>

    <!---------------------------------->
    <div
      v-has-permission="'show_generic_action'"
      v-if="show_generic_display == 1 && all.length > 0 && !showScreen"
      class="custom-btn-generic"
      v-show="withGeneric"
      :class="{ filled: startGeneric }"
      @click="videoGenerique('debut')"
    >
      <svg
        version="1.1"
        width="25px"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 511.816 511.816"
        style="enable-background:new 0 0 511.816 511.816;"
        xml:space="preserve"
      >
        <g fill="#ffffff">
          <path
            d="M20.949,298.483v160c0,29.419,23.936,53.333,53.333,53.333h384c29.419,0,53.333-23.915,53.333-53.333v-160H20.949z"
          />
          <polygon points="252.757,48.776 172.927,67.72 239.807,166.131 326.271,146.462 		" />
          <polygon points="150.741,72.99 64.703,93.384 130.879,190.878 217.471,171.187 		" />
          <path
            d="M511.274,93.086l-18.155-68.864c-4.181-16.747-21.333-27.285-38.251-23.424l-71.68,17.024l68.011,100.267l52.117-11.861
			c2.837-0.64,5.269-2.411,6.763-4.885S511.999,95.902,511.274,93.086z"
          />
          <polygon points="360.981,23.091 275.413,43.4 349.055,141.299 428.863,123.144 		" />
          <polygon points="128.447,191.838 94.314,277.15 178.005,277.15 212.138,191.838 		" />
          <polygon points="235.114,191.838 200.981,277.15 284.671,277.15 318.805,191.838 		" />
          <path
            d="M500.949,191.838h-52.501l-34.133,85.333h97.301v-74.667C511.615,196.595,506.858,191.838,500.949,191.838z"
          />
          <polygon points="341.781,191.838 307.647,277.15 391.317,277.15 425.471,191.838 		" />
          <path
            d="M42.517,98.675l-17.387,4.117c-8.469,1.92-15.637,7.061-20.181,14.443c-4.544,7.403-5.888,16.107-3.776,24.533
			l19.776,78.165v57.216h50.389l32.021-80.021l5.205-1.173L42.517,98.675z"
          />
        </g>
      </svg>
    </div>

    <!---------------------------------->
    <div class="custom-button-navigation--left" @click="dragSlide($event, -1)">
      <svg
        viewBox="0 0 32 32"
        width="20px"
        xmlns="http://www.w3.org/2000/svg"
        style="transform: rotate(180deg)"
      >
        <g fill="#939ea7">
          <path
            d="M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
          />
          <path
            d="M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
          />
        </g>
      </svg>
    </div>

    <!---------------------------------->
    <div id="div-draggable" class="slides-panel row">
      <VuePerfectScrollbar
        id="ps-slide-wrapper"
        class="scroll-area"
        ref="ps"
        :use-both-wheel-axes="true"
        @ps-scroll-x="removeSmoothing"
      >
        <div class="row__inner" @mousewheel="scrollHorizontally">
          <draggable
            id="draggable-wrapper"
            style="display: flex;"
            v-model="list"
            @end="reorder"
            @start="getList"
            :move="dragSlide"
          >
            <div
              v-for="(slide, index) in all"
              class="card-wrapper"
              :class="{ extended: slide.isExtended }"
              :key="'list-complete-c-' + index"
              :data-uid="slide.uid"
            >
              <div class="transition-icon-wrapper" v-show="!isExtendedSlides">
                <b-button
                  v-show="show_video_intro"
                  @click="videoGenerique('intro', index)"
                  class="transition-btn"
                  :class="{ active: hasStartGeneric(slide) }"
                >
                  <i class="icon-film-strip"></i>
                </b-button>
              </div>
              <div class="index-segment" v-show="!isExtendedSlides">{{ index + 1 }}</div>
              <custom-panel-card
                :segmenOneScreen="oneScreen"
                :typecard="typecard"
                :index="index"
                :slide="slide"
                :isSelected="slide.uid === currentSegment.uid"
                :removable="all.length > 1"
                :showVideoIntro="{}"
                @selected="selectSegment(slide)"
                @duplicated="handleDuplicateSegment(slide, index)"
                @insertSegment="handleInsertSegment(index)"
                :is-segment-card="true"
                v-show="!isExtendedSlides"
              >
              </custom-panel-card>
              <div
                class="inner-slides-wrapper"
                :style="calculateWidth(slide)"
                :class="{ extended: slide.isExtended }"
                v-show="isExtendedSlides && currentSegment.uid == slide.uid"
              >
                <draggable
                  class="inner-slides-container"
                  :key="segmentKey"
                  id="nested-draggable-wrapper"
                  style="display: flex;"
                  @end="reorderSlides($event, index)"
                  v-model="lists[index]"
                >
                  <div
                    class="slides-transitions-wrapper"
                    v-for="(slideScreen, i) in getScreens(slide)"
                    :key="i"
                  >
                    <div class="index-screen">{{ i + 1 }}</div>

                    <custom-panel-card
                      :typecard="'screen'"
                      :index="i"
                      :segment="slide"
                      :slide="slideScreen"
                      :isSelected="slideScreen.uid === currentSlide.uid"
                      @selected="selectSlide(slide, slideScreen)"
                      @duplicated="handleDuplicateSlideInsideSegment(slide, slideScreen, index, i)"
                    >
                    </custom-panel-card>
                  </div>
                </draggable>

                <!--
                    <div v-show="isExtendedSlides" class="screen-folder small blue screen" v-on:click="handleAppendSlide(index)"><i class="fa fa-plus"></i></div>
-->
              </div>
            </div>


            <div
              v-show="oneScreen"
              class="folder-slide-add"
              v-on:click="handleInsertSegment(lengthSegmentToAdd)"
            >
              <i class="fa fa-plus"></i>
            </div>




            <div
              v-if="!isExtendedSlides && !oneScreen"
              class="custom-folder small blue floder-add-segment "
              v-on:click="handleInsertSegment(lengthSegmentToAdd)"
            >
              <i class="fa fa-plus"></i>
            </div>
            <div
              v-if="isExtendedSlides && !oneScreen"
              class="folder-slide-add"
              v-on:click="handleAppendSlide(currentSegment)"
            >
              <i class="fa fa-plus"></i>
            </div>


          </draggable>
        </div>
      </VuePerfectScrollbar>
    </div>

    <!---------------------------------->

    <div class="custom-button-navigation--right" @click="dragSlide($event, 1)">
      <svg viewBox="0 0 32 32" width="20px" xmlns="http://www.w3.org/2000/svg">
        <g fill="#939ea7">
          <path
            d="M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
          />
          <path
            d="M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
          />
        </g>
      </svg>
    </div>

    <!---------------------------------->
    <div
      v-has-permission="'show_generic_action'"
      v-if="show_generic_display == 1 && all.length > 0 && !showScreen"
      class="custom-btn-generic"
      v-show="withGeneric"
      :class="{ filled: finishGeneric }"
      @click="videoGenerique('fin')"
    >
      <svg
        height="30px"
        style="margin-top: 45px"
        viewBox="0 0 58 58"
        width="30px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="#ffffff" fill-rule="nonzero" transform="translate(0 -1)">
          <path
            d="m14.678 58.9507 1.0678-.2984c1.0270794-.287091 1.6269982-1.3523947 1.34-2.3795l-12.2083-43.6888c-.17227193-.6165569-.58242107-1.139423-1.14021438-1.4535673-.5577933-.3141444-1.21753647-.3938324-1.83408562-.2215327l-.1379.0385c-1.28397381.3587434-2.0340279 1.6904218-1.6753 2.9744l12.2086 43.6888c.2870014 1.0271063 1.3522895 1.6270863 2.3794 1.3401z"
          />
          <path
            id="Shape"
            d="m57.67 28.42c-3.8715209-1.930437-7.4530885-4.3944478-10.64-7.32-.2678864-.245221-.3726619-.6216366-.27-.97 1.579074-5.9738125 2.7517572-12.04771023 3.51-18.18.12-1.02-.43-1.32-1.01-.62-11.38 13.61-31.07-2.49-42.79 9.88.14070884.2634479.25140182.5418575.33.83l7.92 28.36c11.74-12.22 31.36 3.78 42.72-9.8.58-.7.69-1.98.23-2.18z"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import mixin from '../../mixins/Mixin.js';
import mixinEditors from '../../mixins/GrapesMixinEditors';
import mixinGrapesHelpers from '../../mixins/GrapesMixinHelpers';
import mixinTranslate from '../../mixins/GrapesMixinTranslate';
import GrapesMixinPanels from '../../mixins/GrapesMixinPanels';
import CustomPanelCard from './CustomPanelCard';
import HasPermission from '../../core/directives/HasPermission.js';

export default {
  mixins: [mixin, mixinEditors, mixinGrapesHelpers, GrapesMixinPanels, mixinTranslate],
  directives: {
    HasPermission,
  },

  data() {
    return {
      typecard:'segment',
      oneScreen:false,
      showScreen: false,
      show_transition: true,
      segmentKey: 0,
      logoDebut: '',
      logoFin: '',
      list: [],
      lists: [],
      show_video_intro: true,
      show_generic_display: 0,
      oldValue: '',
      opened: true,
      withGeneric: true,
      currentId: null,
      title: '',
      idSelected: 0,
      typeAnimation: '',
      animation: '',
      scrollInterval: null,
      showScroll: false,
      isExtendedSlides: false,
    };
  },
  components: {
    draggable,
    CustomPanelCard,
    VuePerfectScrollbar,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  computed: {
    ...mapGetters({
      all: 'segments/getSelectedSegments',
      currentSlide: 'slides/getCurrent',
      currentSegment: 'segments/getCurrent',
      modal: 'grapes/getModal',
      paramsClient: 'getParamsClients',
      startGeneric: 'segments/getStartGeneric',
      finishGeneric: 'segments/getFinishGeneric',
      hasPermission: 'hasPermission',
      isExtended: 'segments/isExtended',
      duplicatedSegment: 'segments/getduplicatedSegment',
      duplicatedSlideInSegment: 'segments/getduplicatedSlideInSegment',
      lengthSegmentToAdd: 'segments/getLengthSegmentToAdd',
    }),
    hasScrollSlides() {
      if (this.all.length > 0) {
        let count = this.all.length;
        let panelWidth = 0;
        let widthSlides = 0;
        let cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
          if (this.isExtendedSlides) {
            let extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        let panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
  },
  watch: {
    all: {
      handler(all) {
        all.forEach((el, index) => {
          this.lists[index] = this.getScreens(el);
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('slides', ['setCurrentSlide']),
    ...mapActions('segments', [
      'setCurrentSegment',
      'setIndexSegmentToAdd',
      'setLengthSegmentToAdd',
      'setIndexSlideToAdd',
      'setIndexSegmentSlideToAdd',
      'duplicateSegment',
      'duplicateSlideInsideSegment',
      'updateSlideInsideSegment',
      'toggleExtendSegment',
      'reorderSegments',
      'reorderSlidesInsideSegment',
    ]),
    ...mapActions('common', ['setGenericThem', 'setOptionsThemeSelect']),
    setActiveScrollButtons() {
      if (this.all.length > 0) {
        let count = this.all.length;
        let panelWidth = 0;
        let widthSlides = 0;
        let cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
          if (this.isExtendedSlides) {
            let extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        let panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    isActiveScrollSlide(extended) {
      this.$nextTick(() => {
        let index = 0;
        let interval = setInterval(() => {
          index++;
          this.isExtendedSlides = extended;
          this.setActiveScrollButtons();
          if (extended || !extended) {
            clearInterval(interval);
          }
          if (index === 10) {
            clearInterval(interval);
          }
        }, 500);
      });
    },
    getScreens(segment) {
      return segment.screens.filter(s => {
        return (
          s.type.toLowerCase().indexOf('generic') + s.type.toLowerCase().indexOf('blank') === -2
        );
      });
    },
    hasStartGeneric(segment) {
      return segment.screens.some(s => s.type === 'startGeneric');
    },
    hasTransition(segment) {
      return (
        segment.screens[0].transition.in && segment.screens[0].transition.in !== 'no-transition-in'
      );
    },
    hasTransitionSlide(slide) {
      return slide.transition.in && slide.transition.in.length > 0;
    },
    selectSlide(segment, slide) {
      if (slide.uid === this.currentSlide.uid) {
        return;
      }
      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(() => {
        const lastSlide = {
          uid: this.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        this.updateSlideInsideSegment(lastSlide);
        this.generateSlideThmbnail(this.currentSlide.uid);
        setTimeout(() => {
          //Set Current Screen
          this.setCurrentSlide(slide);
          //Set Current Segment by Screen
          this.setCurrentSegment(segment);
          this.removeToolbarCkeditor();
          this.$root.$emit('updateCanvasContent');
          this.setNoAutoplayVideo(editor);
          let videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(player => {
            this.setPausedVideo(player);
          });
          if (
            this.paramsClient.display_default_blocks &&
            Object.keys(this.paramsClient.display_default_blocks).length > 0 &&
            this.paramsClient.modules.show_list_block_action
          ) {
            const blocks = document.querySelector(
              '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
            );
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    selectSegment(slide) {
      if (slide.uid === this.currentSegment.uid) {
        return;
      }
      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(() => {
        const lastSlide = {
          uid: this.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        this.updateSlideInsideSegment(lastSlide);
        this.generateSlideThmbnail(this.currentSlide.uid);
        setTimeout(() => {
          this.setCurrentSlide(slide.screens.filter(s => s.type !== 'startGeneric')[0]);
          this.setCurrentSegment(slide);
          this.removeToolbarCkeditor();
          this.$root.$emit('updateCanvasContent');
          this.setNoAutoplayVideo(editor);
          let videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(player => {
            this.setPausedVideo(player);
          });
          if (
            this.paramsClient.display_default_blocks &&
            Object.keys(this.paramsClient.display_default_blocks).length > 0 &&
            this.paramsClient.modules.show_list_block_action
          ) {
            const blocks = document.querySelector(
              '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
            );
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    handleDuplicateSegment(segment, index) {
      if (this.startGeneric) {
        index++;
      }

      const clone = this.getSegmentCloneThis(segment);
      segment = Object.assign({}, segment, clone);

      let type =  'manyscreen';
      if (this.paramsClient.nb_screen_segment === 1 ){
        type='onescreen';
      }

      this.duplicateSegment({ segment, index ,type});
      this.selectSegment(this.duplicatedSegment)

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    handleDuplicateSlideInsideSegment(segment, slide, segmentIndex, slideIndex) {
      if (this.startGeneric) {
        segmentIndex++;
      }
      if (this.hasStartGeneric(segment)) {
        slideIndex++;
      }
      if (this.currentSlide.uid === slide.uid) {
        const clone = this.getClone();
        slide = Object.assign({}, this.currentSlide, clone);
      }
      this.duplicateSlideInsideSegment({ slide, segmentIndex, slideIndex });


      this.selectSlide(segment,this.duplicatedSlideInSegment);

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    toggleSegmentCards(slide, index, close) {

      if(this.oneScreen)
        return
      this.showScreen = close ? false : !this.showScreen;
      this.toggleExtendSegment(slide);
      //this.isActiveScrollSlide(slide.isExtended);
      this.segmentKey++;
      this.isExtendedSlides = close ? false : !this.isExtendedSlides;
      // this.slide.isExtended = !this.slide.isExtended

    },
    closeSegmentCards() {
      eventHub.$emit('toggleSegmentx', 'close');
    },

    calculateWidth(segment) {
      return {
        width: 'auto', //168+25:0
      };
    },
    addTransition(segment) {
      this.$emit('transitionSelected', Object.assign({}, segment.screens[0]));
    },

    addTransitionSlide(slide) {
      this.$emit('transitionSelected', Object.assign({}, slide));
    },
    videoGenerique(generic, index) {
      if (this.paramsClient.display_themes_elements != null) {
        // initialize idTheme in store for each type generic
        if (generic == 'fin' && this.paramsClient.display_themes_elements.conclusion) {
          this.setGenericThem(this.paramsClient.display_themes_elements.conclusion[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.conclusion);
        }
        if (generic == 'intro' && this.paramsClient.display_themes_elements.intro) {
          this.setGenericThem(this.paramsClient.display_themes_elements.intro[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.intro);
        }
        if (generic == 'debut' && this.paramsClient.display_themes_elements.generic) {
          this.setGenericThem(this.paramsClient.display_themes_elements.generic[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.generic);
        }
      } else this.setGenericThem(0);

      var self = this;
      var mdlDialog = document.querySelector('.gjs-mdl-dialog');
      eventHub.$emit('eventShowListVideo', true);
      eventHub.$emit('displayGenericListVideo', generic);
      var infoContainer = document.getElementById('list_videos');
      infoContainer.setAttribute('generic', generic);
      infoContainer.setAttribute('data-index', this.startGeneric ? index + 1 : index);
      infoContainer.style.display = 'block';
      self.translatePluginsTitle(null, 'add_generic_' + generic);
      /* self.modal.setTitle(self.$t('blocks.add_generic_' + generic));
        self.modal.setContent(infoContainer);
        document.getElementById('CanvOverlay').style.display = 'block';
        self.modal.open();
        self.modal.getModel().once('change:open', function() {
          document.getElementById('CanvOverlay').style.display = 'none';
          eventHub.$emit('eventShowListVideo', false);
        });*/
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    handleInsertSegment(index) {
      this.setIndexSegmentToAdd(index + 1);
      this.setLengthSegmentToAdd(this.all.length);
      this.showSlideListModal();
      this.removeToolbarCkeditor();
    },
    handleAppendSlide(currentSegment) {
      this.setIndexSegmentSlideToAdd(currentSegment.id);
      eventHub.$emit('setShowAddScreen', true);
    },
    showSlideListModal() {
      if (document.getElementById('module-list')) {
        document.getElementById('module-list').style.display = 'block';
      }
      this.$root.$emit('bv::show::modal', 'slide-list-modal');
      eventHub.$emit('hideModalTitleSegment', true);
    },
    reorder(event) {
      this.reorderSegments(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    reorderSlides(event, index) {
      this.reorderSlidesInsideSegment({ event, index });
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
  },
  created() {
    this.show_generic_display = localStorage.getItem('video_generique');
    this.$root.$on('show-list-video', val => {
      this.videoGenerique(val);
    });
    eventHub.$on('switchtoggle', val => {
      this.toggleSegmentCards(val.slide, val.index, val.close);
    });
  },
  mounted() {
    if (this.paramsClient.show_video_intro === '0') this.show_video_intro = false;
    else this.show_video_intro = this.permission.show_intro_video_action;
    this.show_transition = this.permission.show_transition;
    this.isActiveScrollSlide();


    if(this.paramsClient.nb_screen_segment === 1){
      this.typecard='screen';
      this.oneScreen=true;
    }

    this.$root.$on('updateScrollInterval', obj => {
      this.dragSlide(obj.event, obj.position);
    });
  },
};
</script>

<style lang="scss">
@import '../../scss/media-queries';
@import '../../scss/variables';
.panel-pages-container {
  section#ps-slide-wrapper {
    width: 100%;
  }
  .lds-circle {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: rgb(59, 151, 227);
    animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }

  @keyframes lds-circle {
    0%,
    100% {
      animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
    }
    0% {
      transform: rotateY(0deg);
    }
    50% {
      transform: rotateY(1800deg);
      animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
    }
    100% {
      transform: rotateY(3600deg);
    }
  }

  .drag-wrapper {
    display: flex;
    justify-content: center;
  }

  .list-complete-enter,
  .list-complete-leave-active {
    opacity: 0;
  }

  @keyframes nodeInserted {
    from {
      opacity: 0.2;
    }
    to {
      opacity: 0.8;
    }
  }

  .item-dropzone-area {
    height: 2rem;
    background: #888;
    opacity: 0.8;
    animation-duration: 0.5s;
    animation-name: nodeInserted;
  }

  .panel__devices {
    position: initial;
  }

  .list_page {
    height: 90%;
    overflow: overlay;
  }

  div span {
    display: flex;
    margin-bottom: -5px;
  }

  #div-draggable {
    overflow-x: auto;
    overflow-y: hidden;
    margin: 0 5px !important;
    flex-grow: 1;
  }

  .btn-delete-dep {
    font-size: 15px !important;
  }

  .button_screen {
    position: fixed;
    width: 260px;
    bottom: 0px;
    color: rgb(255, 255, 255);
    background-color: rgb(59, 151, 227);
    padding-bottom: 33px;
    border: none;
    font-size: 15px;
    left: 40px;
    -webkit-transition: all 0.15s ease 0s;
    transition: all 0.15s ease 0s;
  }

  .row__inner {
    margin: 0;
    padding-bottom: 5px;
    display: flex;
    transform: translateY(4px);

    .card-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #b2b2b2;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #b2b2b2;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #b2b2b2;
  }

  .gjs-pn-views .gjs-pn-btn {
    width: 16% !important;
    min-width: 35px !important;
    border-bottom: 0 !important;
  }

  .gjs-pn-views-container .gjs-pn-btn {
    width: 16% !important;
    min-width: 35px !important;
    border-bottom: 0 !important;
  }

  .gjs-pn-buttons {
    display: inline !important;
  }

  #gjs-pn-commands .gjs-pn-buttons,
  .gjs-pn-commands .gjs-pn-buttons {
    display: none !important;
  }

  .gjs-pn-panel.gjs-pn-views {
    margin-right: -43px !important;
  }

  .gjs-pn-panel#gjs-pn-views-container,
  .gjs-pn-panel.gjs-pn-views-container {
    height: calc(100% - 210px) !important;
    bottom: 125px !important;
  }

  .gjs-asset-manager {
    display: flex;
    flex-direction: row;
    height: 400px;
    margin: 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .item-li {
    /*margin: 5px;*/
    color: #fff;
  }

  body.custom_body.swal2-height-auto {
    height: 100% !important;
  }

  .transition-icon {
    width: 1.2rem;
  }

  /* always present */
  .expand-transition {
    transition: all 0.3s ease;
    height: 30px;
    padding: 10px;
    background-color: #eee;
    overflow: hidden;
  }

  /* .expand-enter defines the starting state for entering */
  /* .expand-leave defines the ending state for leaving */
  .expand-enter,
  .expand-leave {
    height: 0;
    padding: 0 10px;
    opacity: 0;
  }

  .modal-active {
    display: block;
  }

  .transition-btn {
    border: none !important;
    padding: 0 !important;
    width: 30px !important;
    height: 30px !important;
    background-color: transparent !important;
    opacity: 0.6;
    margin: 0 0 0 10px !important;
    color: #3c5875 !important;
    font-size: 1.6em !important;

    &.active {
      opacity: 1;
    }
  }

  .transition-btn:hover,
  .transition-btn:active,
  .transition-btn:focus {
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  .add-new-screen {
    margin-top: 0px !important;
    width: 160px !important;
    height: 90px !important;
    margin: 0 10px !important;
    background: transparent !important;
    border: 1px dashed #2196f3;
    color: #2196f3;
    transition: 0.2s;

    i {
      font-size: 32px;
    }

    &:hover {
      background-color: #2196f3 !important;
      color: #ffffff;
    }
  }

  .scroll-area {
    padding: 3px;
    .ps__scrollbar-y-rail {
      display: none !important;
      height: 0 !important;
      visibility: hidden !important;
      overflow-y: hidden !important;
    }
  }

  .resize-elements {
    width: calc(100% - 230px) !important;
  }

  .transition-icon-wrapper {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .transition-icon-wrapper-slide {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inner-slides-wrapper {
    height: 98px;
    width: 0;
    margin-bottom: -6px;
    transition: width 0.3s ease-in-out, padding 0.3s ease-in-out;
    overflow: hidden;
    position: relative;
    padding: 0;

    &:hover {
      .add-segment-btn {
        visibility: visible;
        opacity: 1;
      }
    }

    &.extended {
      padding: 2px;
    }

    .inner-slides-container {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;

      .slides-transitions-wrapper {
        display: flex;
        flex-direction: row;
        width: $width-folder + 30;
        transition: width 0.3s ease-in-out;

      }
    }

    .add-segment-btn {
      position: absolute;
      padding: 3px !important;
      font-size: 1em !important;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      right: 0;
      top: 50%;
      visibility: hidden;
      opacity: 0;
      -webkit-transition: visibility 0.3s ease-in-out, opacity 0.3s ease-in-out;
      transition: visibility 0.3s ease-in-out, opacity 0.3s ease-in-out;
      margin-right: 2px !important;
      color: #ffffff !important;
      background-color: #25ad66 !important;
      border: none !important;
      border-radius: 12px !important;
    }
  }
  .button-navigation {
    border: 1px solid #939ea7 !important;
    margin: 12px 5px !important;
    border-radius: 5px;
    font-size: 32px;
    color: #939ea7;
    &--right,
    &--left {
      height: 100%;
    }
    i {
      color: #939ea7;
      width: 1em;
    }
    &.active {
      background-color: #ffffff !important;
      color: #2196f3 !important;
      border: 2px solid #2196f3 !important;
      i {
        background-color: #ffffff !important;
        color: #2196f3 !important;
      }
    }
  }
}
/*------------------*/

.custom-button-navigation {
  &--right {
    cursor: pointer;
    width: 30px;
    height: $height-custom-panel;
    color: #939ea7;
    border-left: 2px solid #939ea7 !important;
    border-right: 1px solid #939ea7 !important;
    svg {
      margin-top: $height-custom-panel/2 - 6;
      width: 12px;
    }
  }
  &--left {
    cursor: pointer;
    border-left: 1px solid #939ea7 !important;
    border-right: 2px solid #939ea7 !important;
    width: 30px;
    height: $height-custom-panel;
    color: #939ea7;
    svg {
      margin-top: $height-custom-panel/2 - 6;
      width: 12px;
    }
  }
  i {
    color: #939ea7;
    width: 1em;
  }
  &.active {
    background-color: #ffffff !important;
    color: #2196f3 !important;
    border: 2px solid #2196f3 !important;
    i {
      background-color: #ffffff !important;
      color: #2196f3 !important;
    }
  }
}

/*-----------------------------------*/
.custom-btn-generic.filled {
  background-color: #2d73bc !important;
}
.custom-btn-generic {
  background-color: #b5bfc9;
  width: 50px;
  height: $height-custom-panel;
  cursor: pointer;
  svg {
    margin-top: $height-custom-panel/2 - 12;
    height: 24px;
  }
}
.index-segment {
  margin-right: 10px;
}

.index-screen {
  font-size: 17px;
  margin-right: 3px;
  margin-top: $height-custom-panel/2-19;
}
.floder-add-segment {
  margin: -6px;
  margin-left: 30px;
  top: 15px;
}

.screen-folder,
.custom-folder {
  cursor: pointer;
  position: relative;
  display: inline-block;
  text-align: center;
}
.screen-folder.small {
  border-top-style: dashed;
  border-bottom-style: dashed;
  border-width: 5px;
  border-color: white;
  margin-top: 3px;
  width: 160px;
  height: 90px;
  //border-radius: 6px 6px 6px 6px;
}

.screen-folder,
.custom-folder.small {
  width: $width-folder;
  height: $height-folder;
  border-radius: 0px 6px 6px 6px;
}
.screen-folder {
  width: 90px !important;
  height: 60px !important;
  top: 2em;
}

.custom-folder:before {
  content: '';
  display: block;
  position: absolute;
}

.custom-folder:after {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
}

.custom-folder.small:before {
  top: -8px;
  left: 0;
  width: 32px;
  height: 8px;
  border-radius: 6px 0px 0px 0px;
}

.custom-folder.small:after {
  top: -16px;
  left: 24px;
  border: 8px solid transparent;
}

.screen-folder span,
.screen-folder i,
.custom-folder p,
.custom-folder i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-folder p {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 15px;
}

.screen-folder.small i,
.custom-folder.small i {
  font-size: 37px;
}

/*Available colors*/
.custom-folder.blue {
  background-color: #7faad7;
}
.custom-folder.blue:before,
.custom-folder.blue span {
  background-color: #7faad7;
}
.custom-folder.blue:after {
  border-bottom-color: #7faad7;
}

.custom-folder.darckblue {
  background-color: #2d73bc;
}
.custom-folder.darckblue:before,
.custom-folder.blue span {
  background-color: #2d73bc;
}
.custom-folder.darckblue:after {
  border-bottom-color: #2d73bc;
}

.custom-folder.darckblue p {
  color: #ffffff;
  color: #ffffff;
  text-overflow: ellipsis;
  margin-left: 0px;
  white-space: normal;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
.custom-folder.blue i {
  color: #4974af;
}

.screen-folder.blue {
  background-color: #7faad7;
}
.screen-folder.blue:before,
.screen-folder.blue span {
  background-color: #7faad7;
}
.screen-folder.blue:after {
  border-bottom-color: #7faad7;
}

.screen-folder.darckblue {
  background-color: #2d73bc;
}
.screen-folder.darckblue:before,
.screen-folder.blue span {
  background-color: #2d73bc;
}
.screen-folder.darckblue:after {
  border-bottom-color: #2d73bc;
}

.screen-folder.darckblue span {
  color: #ffffff;
}
.screen-folder.blue i {
  color: #4974af;
}

/* Block Back to segment */

.backbtn-segment {
  cursor: pointer;
  height: 25px;
  width: 100px;
  background-color: #c2cfdc;
  border-bottom: 1px solid #939ea7 !important;
}
.current-segment-block {
  background-color: #e2e7ed;
  height: 100px;
}
.custom-folder {
  cursor: pointer;
  position: relative;
  display: inline-block;
  text-align: center;
}

.custom-folder.xs {
  width: $width-folder-xs !important;
  height: $height-folder-xs !important;
  top: 2em;
}

.custom-folder:before {
  content: '';
  display: block;
  position: absolute;
}

.custom-folder:after {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
}

.custom-folder.small:before {
  top: -8px;
  left: 0;
  width: 32px;
  height: 8px;
  border-radius: 6px 0px 0px 0px;
}

.custom-folder.small:after {
  top: -16px;
  left: 24px;
  border: 8px solid transparent;
}

.custom-folder span,
.custom-folder i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-folder span {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 15px;
  white-space: nowrap;
}

.custom-folder.small i {
  font-size: 37px;
}

/*Available colors*/
.custom-folder.blue {
  background-color: #7faad7;
}
.custom-folder.blue:before,
.custom-folder.blue span {
  background-color: #7faad7;
}
.custom-folder.blue:after {
  border-bottom-color: #7faad7;
}

.custom-folder.darckblue {
  background-color: #2d73bc;
}
.custom-folder.darckblue:before,
.custom-folder.blue span {
  background-color: #2d73bc;
}
.custom-folder.darckblue:after {
  border-bottom-color: #2d73bc;
}

.custom-folder.darckblue span {
  color: #ffffff;
}
.custom-folder.blue i {
  color: #4974af;
}
.folder-slide-add {
  width: $width-folder - 2;
  height: $height-folder + 4;
  border-radius: 3px 3px 3px 3px;
  background-color: #2d73bc82;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 2px 0;
  i.fa.fa-plus {
    color: #7ea4cb;
    font-size: 34px;
    height: calc(100% - 10px);
    width: calc(100% - 10px);
    border-top-style: dashed;
    border-bottom-style: dashed;
    border-width: 3px;
    border-color: white;
    margin: 5px;
    padding: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// CustomPanelPages.vue?bfcaeaee